export enum FilePickerType {
  pdf = "pdf",
  mp4 = "mp4",
  img = "img",
  link = "link",
}
